export enum HierarchyQueries {
  HierarchyTree = 'hierarchyTree',
  HierarchyTreeItems = 'hierarchyTreeItems',
  HierarchyTreeSearch = 'hierarchyTreeSearch',
}
